export const getDisplayLanguage = (): string | undefined => {
  let officeLanguage: string | undefined;

  try {
    officeLanguage = Office.context?.displayLanguage || Office.context?.contentLanguage;
  } catch {
    officeLanguage = undefined;
  }

  return officeLanguage || navigator.language || undefined;
};
